import * as Yup from 'yup';

import {
  FORM_ERROR_MESSAGES,
  MAX_EMAIL_LENGTH,
  MAX_FIRST_NAME_LENGTH,
  MAX_LAST_NAME_LENGTH,
  MIN_LENGTH
} from '@hero/constants';
import { isEmailValid, isNameValid } from '@hero/utils';

export const addNewContactSchema = Yup.object().shape({
  email: Yup.string()
    .email()
    .min(MIN_LENGTH)
    .max(MAX_EMAIL_LENGTH)
    .required()
    .test('is-valid', FORM_ERROR_MESSAGES.invalidEmail, value => isEmailValid(value)),
  birthday: Yup.string()
    .test(
      'is-valid',
      FORM_ERROR_MESSAGES.invalidBirthday,
      value => value?.length === 5 || value?.length === 10 || !value?.length
    )
    .optional(),
  anniversary: Yup.string()
    .test(
      'is-valid',
      FORM_ERROR_MESSAGES.invalidAnniversary,
      value => value?.length === 5 || value?.length === 10 || !value?.length
    )
    .optional(),
  tags: Yup.array().optional(),
  firstName: Yup.string()
    .min(MIN_LENGTH, FORM_ERROR_MESSAGES.min2Char)
    .max(MAX_FIRST_NAME_LENGTH, FORM_ERROR_MESSAGES.max30Char)
    .required(FORM_ERROR_MESSAGES.firstNameRequired)
    .test('is-valid', FORM_ERROR_MESSAGES.invalidFirstName, value => isNameValid(value)),
  lastName: Yup.string()
    .min(MIN_LENGTH, FORM_ERROR_MESSAGES.min2Char)
    .max(MAX_LAST_NAME_LENGTH, FORM_ERROR_MESSAGES.max30Char)
    .required(FORM_ERROR_MESSAGES.lastNameRequired)
    .test(
      'is-valid',
      () => FORM_ERROR_MESSAGES.invalidLastName,
      value => isNameValid(value)
    )
});
